import { createContext, useContext, useState, useRef, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { pages } from 'components/RCPro/helpers/nav'
import api from 'helpers/api'

const ClientContext = createContext()

export const PriceProvider = ({ children }) => {
    const { pathname, search } = useLocation()
    const [price, setPrice] = useState(() => {
        const cached = sessionStorage.getItem('priceData')
        return cached ? JSON.parse(cached) : {}
    })
    const prevPath = useRef(null)
    const abortRef = useRef(null)
    const cancelation = useRef(Promise.resolve())

    useEffect(() => {
        const pageSplit = pathname.split('/')
        const page = pageSplit.slice(-1)[0]
        if (page !== 'oups') {
          prevPath.current = pageSplit.length > 3 && pages.includes(page) && page ? page+search : 'index'
        }
    }, [pathname, search])

    const getPrice = async ({ codeProduct, turnover, activity, token, check }) => {
        // Checking if there is data or pending request
        if (check && (Object.keys(price).length > 0 || abortRef.current)) {
            return
        }

        // If there is a pending request, we abort it
        if (abortRef.current) {
            abortRef.current.abort()
            abortRef.current = null
            cancelation.current = new Promise((resolve) => {
                cancelation.current.resolve = resolve
            })
        } else {
            cancelation.current = Promise.resolve()
        }

        // Cleaning datas
        setPrice({})
        sessionStorage.removeItem('priceData')

        try {
            // Ensure that there is no pending cancelation
            await cancelation.current

            // Create abort controller
            const controller = new AbortController()
            abortRef.current = controller

            // Request
            const tarificateur = await api.get({
                url: `/rater/${codeProduct}/${turnover}/${activity}`,
                headers: { Authorization: `Bearer ${token}`},
                signal: controller.signal
            })

            // Save data
            setPrice(tarificateur)
            sessionStorage.setItem('priceData', JSON.stringify(tarificateur))
        } catch (err) {
            console.error('Tarificateur issue:', err)
        } finally {
            abortRef.current = null
            cancelation.current.resolve?.()
        }
    }

    return (
        <ClientContext.Provider value={{ price, getPrice, page: prevPath.current }}>
            {children}
        </ClientContext.Provider>
    )
}

export const usePrice = () => useContext(ClientContext)